module.exports = __webpack_public_path__ + "img/reply.47bf9e9d.svg";